import { createFileRoute } from '@tanstack/react-router';
import { EventContainer } from '@/EventContainer';
import { useCart } from '@/providers/CartProvider';
import { useEffect, useRef } from 'react';

export const Route = createFileRoute('/$slug/_layout/$event')({
  component: Event,
});

function Event() {
  const { event } = Route.useParams();
  const { applyCoupon, getCartState, ticketApiReady } = useCart();
  const couponApplied = useRef(false);
  
  useEffect(() => {
    const applyQueryCouponCode = async () => {
      if (couponApplied.current) {
        return;
      }
      
      const searchParams = new URLSearchParams(window.location.search);
      const couponCode = searchParams.get('couponcode');
      
      if (couponCode) {
        const cartState = getCartState();
        
        if (cartState === 'loading') {
          // Still loading, wait for it to complete
          return; // Exit early, will retry when loading is done
        }
        
        if (!ticketApiReady) {
          // ticketApi not ready yet, wait for it
          return; // Exit early, will retry when ticketApi is ready
        }
        
        // Cart is either loaded or there's no cart - safe to proceed
        try {
          const result = await applyCoupon(couponCode);
          
          if (result === true) {
            couponApplied.current = true;
          } else if (result === "failed to apply coupon") {
            // Don't set couponApplied.current = true, so it can be retried
            // The useEffect will run again when ticketApi becomes ready
          } else {
            // Don't set couponApplied.current = true, so it can be retried
          }
        } catch {
          // Don't set couponApplied.current = true, so it can be retried
        }
      }
    };
    
    applyQueryCouponCode();
  }, [getCartState, ticketApiReady, applyCoupon]); // Depend on getCartState, ticketApiReady, and applyCoupon
  
  return <EventContainer eventSlug={event} />;
} 
